import { requiredLabel } from 'utils/form';
import MultiSlider from '../../MultiSlider';
import type { FieldRendererProps } from '../types';

export function SliderField({ field, onChange }: FieldRendererProps) {
  return (
    <MultiSlider
      selectOptions={field.selectOptions.slice().reverse()}
      label={requiredLabel(field.label, field.required)}
      onChange={onChange}
    />
  );
}
